<template>
  <span
    v-if="residence && residence.availability_months.length > 0"
    class="offersTable"
  >
    <a 
      :href="url"
      target="_blank"
    > 
      {{ $t('iframe.rent') }} ({{ total_availabilities }})
    </a>
    <i v-if="restriction > 0" class="el-icon-lock"></i>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "ResidenceOffers",
  components: {},
  props: {
    residence: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState({
      residenceOffers: state => state.residences.residenceOffers
    }),
    offers() {
      return this.residenceOffers[this.residence.id]
    },
    months() {
      // Fix for Safari
      return this.residence.availability_months
        .map(month => {
          const monthYear = month.split('-')

          if (monthYear[1].length < 2) {
            monthYear[1] = "0" + monthYear[1]
          }

          return monthYear[0] + '-' + monthYear[1]
        })
    },
    total_availabilities() {
      return this.offers ? 
        this.offers.reduce((pOffer,nOffer) => pOffer + nOffer.availabilities.reduce((p,n) => p + n.quantity, 0), 0) : 0
    },
    restriction() {
      return this.offers ? 
        this.offers.reduce((pOffer,nOffer) => pOffer + nOffer.booking_restriction.enabled ? 1 : 0, 0) : 0
    },
    url() {
      return (
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/residences/' +
        this.residence.id +
        '/reservation-d-un-logement'
      )
    }
  },
  watch: {
    residence: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.availability_months) {
          this.activeName = this.months[0]
          this.refreshData(this.activeName)
        }
      }
    }
  },
  methods: {
    async refreshData(yearMonth) {
      if (this.residence) {
        this.loading = true
        await this.$store.dispatch('residences/getResidenceOffers', {
          id: this.residence.id,
          year_month: yearMonth
        })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.offersTable';

#{$c} {
  & a {
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
    font-size: 16px;
    background-color: $--color-secondary;
    color: #ffffff !important;
    padding: 0.5rem 1rem;
    margin: 0.5rem;
  }
}
</style>